import React from "react";
import { Card } from "antd";

const ContactDetails = ({  contact }) => {
 

  return (

        <div>        
            <Card key={contact._id} style={{ marginBottom: 16 }}>
              <p><strong>Name:</strong> {contact?.name}</p>
              <p><strong>Email:</strong> {contact?.email}</p>
              <p><strong>Message:</strong> {contact?.message}</p>
              <p><strong>Created At:</strong> {new Date(contact.createdAt).toLocaleString()}</p>
          </Card>
        </div>
  );
};

export default ContactDetails;
